// Typically this type comes from the `graphql` package.
// This is a hack to remove that dependency
type DocumentNode = any;

export enum AppStatus {
  UPCOMING = 'upcoming',
  PREMIUM = 'premium',
  BETA = 'beta',
  FEATURED = 'featured',
}

// Loosely typed types to support dynamic `useQuery`.
export type OperationVariables = Record<string, any>;

export type QueryResult<Data = any> = {
  client: any;
  data: Data;
  error?: any;
  loading: boolean;
  networkStatus: any;
  called: boolean;
};

type MutationOptions = {};

type FetchResult<TData = {}> = {
  data?: TData | null;
  extensions?: any;
  context?: any;
};

type MutateFunction = (opts: MutationOptions) => Promise<FetchResult>;

export type UseMutation = (
  query: DocumentNode,
  opts: MutationOptions
) => [MutateFunction, QueryResult];
